import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { translation } from '../../translation';
import useLoggedStatus from '../../hooks/useLoggedStatus';
import { logOut } from '../../redux/appSlices/auth/authSlice';
import EditComponants from './EditComponants';

const Footer = () => {
  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo
  );
  const lang = useSelector(
    (state) => state.collaborator.collaboratorInfo.language
  );

  const [openEditPopup, setOpenEditPopup] = useState(false)

  const logged = useLoggedStatus();
  const dispatch = useDispatch()

  return (
    <>
      <footer className={`mt-auto bg-black text-white py-11 px-[1.3rem]`} style={collaborator?.branding?.color ? { backgroundColor: `${collaborator.branding.color}` } : {}}>
        <div
          style={{
            width: collaborator?.branding?.footerLogoSize?.width || '7.3rem',
            height: collaborator?.branding?.footerLogoSize?.height || '2rem',
          }}
        >
          <img
            src={
              collaborator?.branding?.logo_footer
                ? process.env.REACT_APP_IMAGE_PATH + collaborator.branding.logo_footer
                : "/assets/img/logo.svg"
            }
            className="object-contain w-full h-full"
            alt="PopCard"
            srcSet=""
            id="footer-start"
          />
        </div>

        {/* <p className='mt-[30px] text-lg tracking-[-.2px] leading-5'>{!collaborator?.branding && `${collaborator.first_name} ${translation?.footer?.title?.[lang]}`}</p> */}

        <p className="mt-[30px] text-lg tracking-[-.2px] leading-5">
          {!collaborator?.branding
            ? `${collaborator.first_name} ${translation?.footer?.title?.[lang]}`
            : collaborator?.branding.footer_text
              ? collaborator?.branding.footer_text[lang]
              : null}
        </p>

        <div className='flex justify-between mt-8 w-full'>
          <a className='flex items-center justify-center border-[0.8px] rounded-md text-sm min-h-[3.1rem] w-[180px] cursor-pointer' href="https://getpopcard.com/order" >{translation?.footer?.button?.[lang]}</a>

          {
            logged ?
              <div
                className={`flex items-center justify-center border-[0.8px] rounded-md text-sm min-h-[3.1rem] w-[180px] cursor-pointer ${lang === 'ar' ? 'mr-[20px]' : 'ml-[20px]'}`}
                onClick={() => {
                  dispatch(logOut());
                  const keys = Object.keys(localStorage);
                  keys.forEach((key) => {
                    if (key !== "user_token") {
                      localStorage.removeItem(key);
                    }
                  });
                  localStorage.setItem("logout", "true");
                  window.location.reload();
                }}>
                {translation.loginPage.buttonLogout?.[lang]}
              </div>
              :
              <div
                className={`flex items-center justify-center border-[0.8px] rounded-md text-sm min-h-[3.1rem] w-[180px] cursor-pointer ${lang === 'ar' ? 'mr-[20px]' : 'ml-[20px]'}`}
                onClick={() => {
                  setOpenEditPopup(true)
                }}
              >
                {translation?.loginPage?.loginTitle?.[lang]}
              </div>
          }

        </div>
        {!collaborator?.branding && <div className='text-[#5a5856] text-sm text-center mt-20'>
          {translation?.footer?.reserved?.[lang]} © 2022 Popcard.com
        </div>}

      </footer>

      {openEditPopup && (
        <EditComponants
          componantId={12}
          setOpenEditPopup={setOpenEditPopup}
        />
      )}
    </>
  )
}

export default Footer